import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="section bg-gradient-biotech relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '48px 48px'
        }}></div>
      </div>

      <div className="relative container-custom">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-white mb-6">
            Ready to Request a Quote?
          </h2>
          <p className="text-xl text-white/90 mb-4 leading-relaxed max-w-2xl mx-auto">
            Get personalized pricing and availability for your research needs. All orders require manual quote approval before payment.
          </p>
          <p className="text-white/80 mb-10 text-sm">
            MOQ: 1 unit • Lead Time: 5-10 business days • Worldwide delivery to qualified institutions
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Link
              to="/contact"
              className="btn btn-lg bg-white text-navy-900 hover:bg-gray-100 focus-visible:ring-white"
            >
              Request Quote
              <i className="ri-file-list-3-line ml-2"></i>
            </Link>
            <a
              href="https://wa.me/639178850200"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-lg bg-green-600 text-white hover:bg-green-700 focus-visible:ring-green-400"
            >
              <i className="ri-whatsapp-line mr-2 text-xl"></i>
              WhatsApp Inquiry
            </a>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-8 text-white/90">
            <div className="flex items-center gap-2.5">
              <i className="ri-file-list-3-line text-xl"></i>
              <span className="text-sm font-medium">Quote-Based Ordering</span>
            </div>
            <div className="flex items-center gap-2.5">
              <i className="ri-shield-check-line text-xl"></i>
              <span className="text-sm font-medium">Manual Approval Process</span>
            </div>
            <div className="flex items-center gap-2.5">
              <i className="ri-building-line text-xl"></i>
              <span className="text-sm font-medium">B2B Research Supply</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}